<script lang="ts">// prettier-ignore
const { size = 'regular', isToggled = false, class: className = '', ...rest } = $props();
export {};
</script>

<span
  {...rest}
  class="AccordionToggle AccordionToggle--{size} {className}"
  class:AccordionToggle--toggled={isToggled}
></span>

<style>@layer design-system-components.pwds {
  .AccordionToggle {
    position: relative;
    display: inline-block;
    height: var(--accordion-toggle-size);
    width: var(--accordion-toggle-size);
  }
  .AccordionToggle, .AccordionToggle.AccordionToggle--regular {
    --accordion-toggle-size: var(--accordion-toggle-size-regular-dimensions);
    --accordion-toggle-line-height: var(--accordion-toggle-size-regular-line-height);
  }
  .AccordionToggle.AccordionToggle--small {
    --accordion-toggle-size: var(--accordion-toggle-size-small-dimensions);
    --accordion-toggle-line-height: var(--accordion-toggle-size-small-line-height);
  }
  .AccordionToggle:before, .AccordionToggle:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    height: var(--accordion-toggle-line-height);
    width: var(--accordion-toggle-size);
    background-color: var(--color-text);
    transition: transform var(--duration-slow) var(--easing-sharp);
  }
  @media (prefers-reduced-motion: reduce) {
    .AccordionToggle:before, .AccordionToggle:after {
      transition: none;
    }
  }
  .AccordionToggle:before {
    transform: translate3d(-50%, -50%, 0);
  }
  .AccordionToggle:after {
    transform: translate3d(-50%, -50%, 0) rotate(90deg);
  }
  .AccordionToggle--toggled:before {
    transform: translate3d(-50%, -50%, 0) rotate(-180deg);
  }
  .AccordionToggle--toggled:after {
    transform: translate3d(-50%, -50%, 0) rotate(-90deg) scaleX(0);
  }
}</style>
